// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discord-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  background: var(--glass-bg);
  color: #5865f2;
  transition: background 0.15s ease, color 0.15s ease;
}

.discord-link:hover,
.discord-link:focus-visible {
  background: #5865f2;
  color: var(--color-white);
}

.discord-link-icon {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/DiscordLink.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;EACd,mDAAmD;AACrD;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".discord-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  background: var(--glass-bg);\n  color: #5865f2;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.discord-link:hover,\n.discord-link:focus-visible {\n  background: #5865f2;\n  color: var(--color-white);\n}\n\n.discord-link-icon {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
